import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MonitorIcon } from 'lucide-react';
interface ToastProps {
  show: boolean;
  onClose: () => void;
}
export const Toast: React.FC<ToastProps> = ({
  show,
  onClose
}) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);
  return <AnimatePresence data-id="element-298" data-mp="12x118910ax3j">
      {show && <div data-export-hide className="fixed inset-x-0 top-16 z-50 px-4 flex items-center justify-center pointer-events-none" data-id="element-299" data-mp="17vkms8bou6vd">
          <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 350,
        duration: 0.3
      }} className="w-full max-w-md pointer-events-auto" role="alert" aria-live="polite" data-id="element-300" data-mp="sxs8tklshqja">
            <div className="bg-white border-l-4 border-[#1E90FF] rounded-lg shadow-lg" data-id="element-301" data-mp="z8vytpi16fx1">
              <div className="p-4 flex items-start space-x-3" data-id="element-302" data-mp="u9ja0z7lmyrt">
                <MonitorIcon className="h-5 w-5 text-[#1E90FF] flex-shrink-0 mt-0.5" data-id="element-303" data-mp="ubdxola994zl" />
                <p className="text-sm text-gray-700 font-medium leading-5" data-id="element-304" data-mp="194z619rqp4qu">
                  For the best data visualization experience, we recommend
                  viewing this report on a larger screen.
                </p>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
};